import { useState, useCallback } from "react";
import useRouteState from "src/share/hooks/useRouteState";
import useDidUpdateEffect from "src/share/hooks/useDidUpdateEffect";
import useDebounce from "src/share/hooks/useDebounce";

interface ICasesSearch {
  handleDebounceSearchChange: (searchText: string) => void;
}

export const useCasesSearch = ({
  handleDebounceSearchChange
}: ICasesSearch) => {
  const { routeState } = useRouteState();
  const [isClearingSearchText, setIsClearingSearchText] = useState(false);
  const [searchText, setSearchText] = useState(
    (routeState && routeState.options && routeState.options.search) || ""
  );
  const debouncedText = useDebounce(searchText, 500);
  const handleSearchText = useCallback((text: string) => setSearchText(text), [
    searchText
  ]);

  const handleClearSearchText = useCallback(() => {
    setIsClearingSearchText(true);
    setSearchText("");
  }, []);

  useDidUpdateEffect(() => {
    if (!isClearingSearchText) {
      handleDebounceSearchChange(searchText);
    }
    setIsClearingSearchText(false);
  }, [debouncedText]);

  return {
    searchText,
    handleSearchText,
    handleClearSearchText
  };
};



// WEBPACK FOOTER //
// ./src/modules/Case/View/hooks/useCasesSearch.ts